module.exports.default = {
    "ORDER": "Bestelling",
    "SCHEDULE.YOU_ARE_ALL_SET": "Uw keuze is opgeslagen",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Uw levering staat gepland",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Hallo #, wij vragen u vriendelijk om uw levering te plannen",
    "SCHEDULE.SCHEDULE_NOW": "opnieuw plannen",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Bijwerken van de bestellingen en statussen",
    "SCHEDULE.EMAIL_UPDATES": "E-mail",
    "SCHEDULE.SMS_UPDATES": "SMS",
    "SCHEDULE.DISABLE_UPDATES": "Ik wil geen notificaties meer ontvangen",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Ik wil notificaties ontvangen voor deze levering via:",
    "OOPS": "Oeps!",
    "SOMETHING_WENT_WRONG": "Er is een fout opgetreden bij uw bestelling",
    "REFRESH": "Verversen",
    "PAGE_NOT_FOUND": "Pagina niet gevonden",
    "COULD_NOT_FIND_PAGE": "Wij kunnen de pagina waar u naar zoekt, niet vinden",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Een leeg bericht kan niet verzonden worden",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Stuur uw bericht naar de bezorger",
    "TRACKING.SEND": "Send via messenger",
    "TRACKING.ARRIVING_AT": "Zal aankomen op",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "min",
    "TRACKING.MAP": "Traffic",
    "TRACKING.SATELLITE": "Satellite",
    "TRACKING.TERRAIN": "Terrain",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Hoi, ik ben gearriveerd!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "is gearriveerd op",
    "COMPLETED": "Er staan op dit moment geen bezorgingen gepland",
    "RATING.SKIP": "Liever niet",
    "RATING.WHAT_WENT_WELL": "Positief punt",
    "RATING.WHAT_WENT_WRONG": "Negatief punt",
    "RATING.THANK_YOU": "Bedankt",
    "RATING.FOR_USING_OUR_SERVICE": "Bedankt voor uw bestelling!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Hoe is uw levering verlopen?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Bedankt voor jouw feedback, we gaan hiermee aan de slag!",
    "SCHEDULE.RATE_US": "Beoordeel Ons!",
    "TERM_OF_USE": "Terms of service",
    "PRIVACY_POLICY": "Privacy Policy",
    "SHARING_MY_LOCATION": "Find Me",
    "SHARING_LOADING": "Laden",
    "REQUIRED_FIELD_MESSAGE": "All fields are required",
    "CONTACT_NAME": "Contact Name",
    "PHONE_NUMBER": "Phone Number",
    "EMAIL_ADDRESS": "E-Mail Address",
    "SEND": "Send",
    "FORWARD.THIS_ORDER": "Forward this delivery",
    "FORWARD.TO_CONTACT": "Forward to contact in",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Are you sure you want to forward this order?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "heeft u een levering toegestuurd",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Are you sure you wish to decline this delivery?",
    "ACCEPT": "Accept",
    "REJECT": "Weigeren",
    "PICKUP.SET_PICKUP_TIME": "Het afhaaltijdstip bepalen",
    "PICKUP.IVE_ARRIVED": "Ik ben aangekomen",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Oeps, er is een fout opgetreden",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Probeer het opnieuw",
    "PICKUP.MIN": "min",
    "PICKUP.SHOW_THIS_NUMBER": "Toon dit nummer aan de receptionniste om uw bestelling te ontvangen",
    "PICKUP.IM_OUTSIDE": "Ik ben er",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Waarschuw ons bij aankomst.",
    "PICKUP.I_WILL_ARRIVE_AT": "Ik zal er zijn om",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "Het afhaaltijdstip is met succes ingesteld",
    "PICKUP.IN": "Over",
    "PICKUP.TO": "Om",
    "PICKUP.COLLECT": "Bestelling verzameld",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "De transportmethode selecteren",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "De transportmethode bevestigen",
    "PICKUP.CANCEL": "Annuleren",
    "PICKUP.CONFIRM_TIME": "Het afhaaltijdstip bevestigen",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "De bezorger is momenteel op één halte van u verwijderd",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "haltes voor die van u",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "De bezorger is er",
    "PICKUP.OK": "Ok",
    "PICKUP.NEXT": "Volgende",
    "PICKUP.SKIP": "Overslaan",
    "CAR_ARRIVED.TITLE": "Fijn dat u er bent. Help ons u te lokaliseren:",
    "CAR_ARRIVED.PARKING_SPOT": "Parkeerplaats en nummer van de parkeerplek",
    "CAR_ARRIVED.LICENSE_PLATE": "Kentekennummer",
    "CAR_ARRIVED.VEHICLE_MODEL": "Model en merk van het voertuig",
    "CAR_ARRIVED.VEHICLE_COLOR": "Kleur van het voertuig",
    "CAR_ARRIVED.REMEMBER": "De details van het voertuig onthouden",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Voorbeeld: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Voorbeeld: AA-123-ZZ)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Voorbeeld: Renault Clio)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Voorbeeld: Blauw)",
    "REDIRECT_PICKUP.TO": "Om",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "De afhaallocatie wijzigen",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "De afhaallocatie is met succes gewijzigd",
    "REDIRECT_PICKUP.FAILED_TITLE": "De afhaallocatie kon niet gewijzigd worden",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Er is een fout opgetreden",
    "REDIRECT_PICKUP.OK": "Ok",
    "REDIRECT_PICKUP.KM": "Km",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Een afhaallocatie kiezen",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Als afhaallocatie bepalen",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Afhaalopties",
    "SOON": "Naderend",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "Wilt u uw bezorger contacteren?",
    "GLOBAL.CALL": "Bellen",
    "GLOBAL.CANCEL": "Annuleren",
    "﻿PICKUP.SET_PICKUP_TIME": "Het afhaaltijdstip bepalen",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Uw bestelling staat voor uw deur op u te wachten!",
    "SCHEDULED.THANKS_FOR_USING": "Wij danken u ervoor dat u gebruiktgemaakt heeft van {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "Uw zending {{external_id}} is onderweg",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Uw levering is gepland voor",
    "Submit": "Valideren",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "",
    "PICKUP.SHOW_ID": "De ID weergeven",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "",
    "OPEN_MENU": "",
    "CLOSE_MENU": "",
    "MAP_AUTO_CENTER": "",
    "MAP_SETTINGS": "",
    "ZOOM_OUT": "",
    "ZOOM_IN": "",
    "TRACKING.CALL_DRIVER": "",
    "TRACKING.MESSAGE_DRIVER": "",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "",
    "SCHEDULE.TIME_ZONE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "",
    "TRACKING.THANKS_MESSAGE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_TITLE": "",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "",
    "CANCEL_ORDER": "",
    "CANCELLATION_VALIDATION_TITLE": "",
    "CANCELLATION_VALIDATION_BACK": "",
    "CANCELLATION_VALIDATION_YES": "",
    "CANCEL_SUCCESS": "",
    "CANCEL_PAST_ALLOWED": "",
    "CANCEL_ERROR": "",
    "RATING.FREE_TEXT_COMMENT": "",
    "RATING.ORDER_DELIVERED_GREEN": "",
    "CX_ORDER_STATUS.CONFIRMED": "",
    "CX_ORDER_STATUS.RECEIVED": "",
    "CX_ORDER_STATUS.FINDING_DRIVER": "",
    "CX_ORDER_STATUS.DRIVER_FOUND": "",
    "CX_ORDER_STATUS.PICKING_UP": "",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "",
    "CX_ORDER_STATUS.ARRIVED": "",
    "TRACKING.DELIVERY_STATUS_TITLE": "",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "",
    "CONFIRM": "",
    "FLOW_OPTIONS.TITLE": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "",
    "RATING_STAR_ALT": "",
    "RATING_STAR_ALT_ONE": "",
    "RATING_STAR_ALT_TWO": "",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": ""
};
	